import { defineComponent, onMounted, watch } from 'vue';

import ScholarshipFormCode from './scholarship-form.class';
import { EditorIntegration } from '@/infrastructure/editor-platform/editor-integration';
import ScholarshipFormModel from './scholarship-form-model';

import HtmlEditor from './html-editor/html-editor.vue';
import MassSelect from './mass-select/mass-select.vue';
import DeadlineEditor from './deadline-editor/deadline-editor.vue';
import ProviderEditor from './provider-editor/provider-editor.vue';

export default defineComponent({
	components: {
		HtmlEditor,
		MassSelect,
		DeadlineEditor,
		ProviderEditor,
	},
	props: {
		formModel: ScholarshipFormModel,
	},
	setup: (props) => {
		const code = new ScholarshipFormCode(props.formModel);

		watch(props, async (): Promise<void> => {
			if (props.formModel !== code.formModel.value) {
				await code.replace(props.formModel);
			}
		});

		onMounted(async () => await code.mounted());

		EditorIntegration.instance.formRegister(code);

		return {
			...code,
			validateField: code.validateField.bind(code),
			onAllDestinationCountriesSelected: code.onAllDestinationCountriesSelected.bind(code),
			onAllOriginCountriesSelected: code.onAllOriginCountriesSelected.bind(code),
		};
	},
});
